'use client';

import * as React from 'react';
import Image, { ImageProps } from 'next/image';
import Icon, { IconsAvailable } from '@/components/ui/Icon';

export interface IImageWithFallbackProps extends ImageProps {
  icon: IconsAvailable;
}

const ImageWithFallback: React.FunctionComponent<IImageWithFallbackProps> = (props) => {
  const { icon, ...rest } = props;
  const [imageError, setImageError] = React.useState(false);

  React.useEffect(() => {
    setImageError(false);
  }, [props.src]);

  return (
    <React.Fragment>
      {props.src && !imageError ? (
        <Image
          {...rest}
          alt={rest.alt}
          onError={() => {
            setImageError(true);
          }}
        />
      ) : (
        <Icon
          width={typeof props.width === 'number' ? props.width : 16}
          height={typeof props.height === 'number' ? props.height : 16}
          kind={icon}
          className={props.className}
        />
      )}
    </React.Fragment>
  );
};

ImageWithFallback.displayName = 'ImageWithFallback';

export default ImageWithFallback;
